import { useEffect, useRef } from "react";
import { ADSENSE_CLIENT, type AdPlacement } from "./adsConfig";
import { loadAdSense } from "./loadAdSense";
import { useAdConsent } from "./useAdConsent";

interface Props {
  placement: AdPlacement;
  /** Pro non-personalized (před consentem) */
  npa?: boolean;
}

export function AdSenseUnit({ placement, npa = false }: Props) {
  const ref = useRef<HTMLModElement>(null);
  const consent = useAdConsent();
  const pushedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    loadAdSense()
      .then(() => {
        if (cancelled || pushedRef.current) return;
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          pushedRef.current = true;
        } catch (e) {
          // ignore
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const insProps: Record<string, string> = {
    "data-ad-client": ADSENSE_CLIENT,
  };
  if (placement.slot) insProps["data-ad-slot"] = placement.slot;
  if (placement.format === "in-feed") {
    insProps["data-ad-format"] = "fluid";
    if (placement.layoutKey) insProps["data-ad-layout-key"] = placement.layoutKey;
  } else if (placement.format === "in-article") {
    insProps["data-ad-format"] = "fluid";
    insProps["data-ad-layout"] = "in-article";
  } else {
    insProps["data-ad-format"] = "auto";
    insProps["data-full-width-responsive"] = "true";
  }
  if (npa || consent !== "granted") {
    insProps["data-npa"] = "1";
  }

  return (
    <ins
      ref={ref as any}
      className="adsbygoogle block"
      style={{ display: "block", minHeight: placement.minHeight }}
      {...insProps}
    />
  );
}
